// extracted by mini-css-extract-plugin
export default {"title":"b7-z","warning":"c7-z","sizeOptionsLegendText":"d7-z"};